var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.singleTobObj.devcBaseInfoFalg
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _vm.shopDeviceSubNo.suitMainFlag
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("主")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shopDeviceSubNo.tagMissing
                      ? _c("el-tag", { attrs: { type: "warning" } }, [
                          _vm._v("缺码")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      { attrs: { title: _vm.shopDeviceSubNo.title || "无" } },
                      [_vm._v(_vm._s(_vm.shopDeviceSubNo.title || "无"))]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.shopDeviceSubNo.name || "无" } },
                    [_vm._v(_vm._s(_vm.shopDeviceSubNo.name || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.shopDeviceSubNo.brandName || "无" } },
                    [_vm._v(_vm._s(_vm.shopDeviceSubNo.brandName || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.shopDeviceSubNo.model || "无" } },
                    [_vm._v(_vm._s(_vm.shopDeviceSubNo.model || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.shopDeviceSubNo.fixedSpec || "无" } },
                    [_vm._v(_vm._s(_vm.shopDeviceSubNo.fixedSpec || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    {
                      attrs: { title: _vm.shopDeviceSubNo.vendorUkno || "无" }
                    },
                    [_vm._v(_vm._s(_vm.shopDeviceSubNo.vendorUkno || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.shopDeviceSubNo.specialFlag ? "是" : "否")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.useMannerMap[_vm.shopDeviceSubNo.useManner] || "无"
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.shopDeviceSubNo.createTime || "无"))
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.singleTobObj.repairInfoFalg
        ? [
            _vm._m(10),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _vm.shopDeviceSubNo.wrntDueTime != null &&
                      new Date(_vm.shopDeviceSubNo.currentTime).getTime() >
                        new Date(_vm.shopDeviceSubNo.wrntDueTime).getTime()
                        ? _c("span", { staticClass: "font-red" }, [
                            _vm._v("否")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.shopDeviceSubNo.wrntDueTime == null ||
                      new Date(_vm.shopDeviceSubNo.currentTime).getTime() <=
                        new Date(_vm.shopDeviceSubNo.wrntDueTime).getTime()
                        ? _c("span", { staticClass: "font-green" }, [
                            _vm._v("是")
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(12),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.wrntPeriod || "0"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.wrntStartTime || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(14),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.wrntDueTime || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(15),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.shopDeviceSubNo.patrolFlag ? "是" : "否")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(16),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.shopDeviceSubNo.maintFlag ? "是" : "否")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(17),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.shopDeviceSubNo.setupFlag ? "是" : "否")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(18),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c(
                        "span",
                        {
                          attrs: {
                            title: _vm.shopDeviceSubNo.temperFlag
                              ? "需要"
                              : "不需要"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.shopDeviceSubNo.temperFlag ? "需要" : "不需要"
                            )
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(19),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.faultTimes || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(20),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.repairTimes || "0"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(21),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.shopDeviceSubNo.lastRepairMainTime || "无")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(22),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.shopDeviceSubNo.wrntExtVoucherId == -1
                    ? _c("span", [_vm._v("无")])
                    : _c("span", [
                        _vm._v(
                          _vm._s(_vm.shopDeviceSubNo.WrntExtVoucherNo || "无")
                        )
                      ])
                ])
              ]),
              _vm._v(" "),
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(23),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.shopDeviceSubNo.devcGroupFullName || "")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(24),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.devcDefTitle || ""))
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.singleTobObj.manageInfoFalg
        ? [
            _vm._m(25),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(26),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.shopDeviceSubNo.retailerBizUnitName || "无")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(27),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.retailerShopName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(28),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.departName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(29),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.principalName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(30),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.shopDeviceSubNo.lng || "无"))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(31),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.shopDeviceSubNo.lat || "无"))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(32),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.shopDeviceSubNo.indoubtFlag == 1 ? "是" : "否")
                    )
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.singleTobObj.useInfoFalg
        ? [
            _vm._m(33),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(34),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.initStartDate || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(35),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.startDate || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(36),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.shopDeviceSubNo.useState == _vm.inactiveValue
                    ? _c("div", [
                        _c("span", { staticClass: "font-black" }, [
                          _vm._v("未启用")
                        ])
                      ])
                    : _vm.shopDeviceSubNo.useState == _vm.outageValue
                    ? _c("div", [
                        _c("span", { staticClass: "font-gold" }, [
                          _vm._v("已停用")
                        ])
                      ])
                    : _vm.shopDeviceSubNo.useState == _vm.startValue
                    ? _c("div", [
                        _c("span", { staticClass: "font-green" }, [
                          _vm._v("已启用")
                        ])
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(37),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.shopDeviceSubNo.state == 0
                    ? _c("span", { staticClass: "font-green" }, [
                        _vm._v("正常")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shopDeviceSubNo.state == 1
                    ? _c("span", { staticClass: "font-red" }, [
                        _vm._v("有故障")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shopDeviceSubNo.state == 2
                    ? _c("span", { staticClass: "font-black" }, [
                        _vm._v("已报修")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shopDeviceSubNo.state == 3
                    ? _c("span", { staticClass: "font-black" }, [
                        _vm._v("维修中")
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(38),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.inUse ? "是" : "否"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(39),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.shopDeviceSubNo.inStock ? "是" : "否")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(40),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.locked ? "是" : "否"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(41),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.shopDeviceSubNo.actTime || "无"))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.infoType == null || _vm.infoType == "change"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(42),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.shopDeviceSubNo.qrScanTime || "无"))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(43),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.usagedDepartName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(44),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.usagedStaffName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(45),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.suitName || "无"))
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.singleTobObj.devcStatisInfoFalg
        ? [
            _vm._m(46),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(47),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.theUnit || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(48),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _vm._l(_vm.shopDeviceSubNo.tagNames, function(tagName) {
                      return [
                        _c(
                          "span",
                          { staticClass: "swb-tags swb-tags-success mr5" },
                          [_vm._v(_vm._s(tagName))]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(49),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.shopDeviceSubNo.retailerShopTagName || "无")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(50),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.inStock ? 1 : 0))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(51),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.startTimeDay || "0"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(52),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.outageTimeMi || "0"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(53),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        ((_vm.shopDeviceSubNo.curIdleTimeMi || 0) / 60).toFixed(
                          1
                        )
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(54),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s((_vm.shopDeviceSubNo.idleTimeMi / 60).toFixed(1))
                    )
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.singleTobObj.assetBaseInfoFalg
        ? [
            _vm._m(55),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(56),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.innerCode || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(57),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.assetNatureMap[_vm.shopDeviceSubNo.assetNature] ||
                          "无"
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(58),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.innerDevcCatName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(59),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.shopDeviceSubNo.innerNo || "无" } },
                    [_vm._v(_vm._s(_vm.shopDeviceSubNo.innerNo || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(60),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.leasible ? "是" : "否"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(61),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.splitible ? "是" : "否"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.infoType == "fiscal"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(62),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.shopDeviceSubNo.initInnerCode || "无")
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(63),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.useMannerMap[_vm.shopDeviceSubNo.useManner] || "无"
                      )
                    )
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.singleTobObj.financeInfoFalg
        ? [
            _vm._m(64),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(65),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.shopDeviceSubNo.deprSpecId != null &&
                  _vm.shopDeviceSubNo.deprSpecId != -1
                    ? _c("span", [
                        _c(
                          "a",
                          {
                            staticClass: "table-cell-link",
                            on: {
                              click: function($event) {
                                _vm.showDeprSpec(_vm.shopDeviceSubNo.deprSpecId)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.shopDeviceSubNo.deprSpecCode))]
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(66),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.shopDeviceSubNo.ntxPrice != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.shopDeviceSubNo.ntxPrice.toFixed(2) || 0.0)
                        )
                      ])
                    : _c("span", [_vm._v("0.00")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(67),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.shopDeviceSubNo.price != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.shopDeviceSubNo.price.toFixed(2) || 0.0)
                        )
                      ])
                    : _c("span", [_vm._v("0.00")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(68),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.fiscalInTime || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(69),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.acctEnterWayMap[_vm.shopDeviceSubNo.acctEnterWay]
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(70),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.durableLife || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(71),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.assetDeprMethodMap[
                          _vm.shopDeviceSubNo.deprMethodCode
                        ] || "无"
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(72),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.shopDeviceSubNo.currentMonthDepr != null
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.shopDeviceSubNo.currentMonthDepr.toFixed(2)
                          )
                        )
                      ])
                    : _c("span", [_vm._v("0.00")])
                ])
              ]),
              _vm._v(" "),
              _vm.shopDeviceSubNo.fiscalAcctFlag == 1
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(73),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _vm.shopDeviceSubNo.deprOver
                        ? _c("span", { staticClass: "font-red" }, [
                            _vm._v("是")
                          ])
                        : _c("span", [_vm._v("否")])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(74),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.rmnWorthRatio || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(75),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.shopDeviceSubNo.orgWorth == null
                          ? "无"
                          : _vm.shopDeviceSubNo.orgWorth.toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(76),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.shopDeviceSubNo.netWorth == null
                          ? "无"
                          : _vm.shopDeviceSubNo.netWorth.toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(77),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.lastDeprMonth || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(78),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.shopDeviceSubNo.taxRate == null
                          ? "无"
                          : _vm.shopDeviceSubNo.taxRate.toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.shopDeviceSubNo.deprMethodCode == "SLD" ||
              _vm.shopDeviceSubNo.deprMethodCode == "ASM"
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(79),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("div", { staticClass: "form-value" }, [
                        _vm.shopDeviceSubNo.cnt1stMonth
                          ? _c("span", { staticClass: "font-red" }, [
                              _vm._v("首月")
                            ])
                          : _c("span", [_vm._v("次月")])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(80),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.shopDeviceSubNo.aggtDeprWorth == null
                          ? "无"
                          : _vm.shopDeviceSubNo.aggtDeprWorth.toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(81),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.leftMonths || 0))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(82),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.scrapped ? "是" : "否"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(83),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.scrapDate || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(84),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.fiscalOutTime || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(85),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.devcClearCauseMap[_vm.shopDeviceSubNo.clearCause] ||
                          "无"
                      )
                    )
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.singleTobObj.assetStatisInfoFalg
        ? [
            _vm._m(86),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(87),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.fiscalAcctFlag || 0))
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.singleTobObj.srcInfoFalg
        ? [
            _vm._m(88),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(89),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.batchNo || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(90),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.shopDeviceSubNo.vendorSn || "无" } },
                    [_vm._v(_vm._s(_vm.shopDeviceSubNo.vendorSn || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(91),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    { attrs: { title: _vm.shopDeviceSubNo.upn || "无" } },
                    [_vm._v(_vm._s(_vm.shopDeviceSubNo.upn || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(92),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.sellerName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(93),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c(
                    "span",
                    {
                      attrs: {
                        title: _vm.shopDeviceSubNo.innerVendorNo || "无"
                      }
                    },
                    [_vm._v(_vm._s(_vm.shopDeviceSubNo.innerVendorNo || "无"))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(94),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.initContractNo || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(95),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.receiveTime || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(96),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.shopDeviceSubNo.imported ? "是" : "否"))
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.singleTobObj.imgInfoFalg
        ? [
            _vm._m(97),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(98),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.shopDeviceSubNo.imageUrl != null &&
                  _vm.shopDeviceSubNo.imageUrl.length > 0
                    ? _c("div", { staticClass: "file-area clearfix" }, [
                        _c(
                          "div",
                          {
                            staticClass: "file-item image viewable downloadable"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "file-content",
                                on: {
                                  click: function($event) {
                                    _vm.viewImage(_vm.shopDeviceSubNo.imageUrl)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: { src: _vm.shopDeviceSubNo.imageUrl }
                                }),
                                _vm._v(" "),
                                _vm._m(99)
                              ]
                            )
                          ]
                        )
                      ])
                    : _c("div", [
                        _c("img", {
                          directives: [
                            {
                              name: "resc-url",
                              rawName: "v-resc-url",
                              value: "/image/noimg.jpg",
                              expression: "'/image/noimg.jpg'"
                            }
                          ]
                        })
                      ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(100),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.shopDeviceSubNo.shopDevice != null &&
                  _vm.shopDeviceSubNo.shopDevice.imageUrl != null &&
                  _vm.shopDeviceSubNo.shopDevice.imageUrl != ""
                    ? _c("div", { staticClass: "file-area clearfix" }, [
                        _c(
                          "div",
                          {
                            staticClass: "file-item image viewable downloadable"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "file-content",
                                on: {
                                  click: function($event) {
                                    _vm.viewImage(
                                      _vm.shopDeviceSubNo.shopDevice.imageUrl
                                    )
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.shopDeviceSubNo.shopDevice.imageUrl
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(101)
                              ]
                            )
                          ]
                        )
                      ])
                    : _c("div", [
                        _c("img", {
                          directives: [
                            {
                              name: "resc-url",
                              rawName: "v-resc-url",
                              value: "/image/noimg.jpg",
                              expression: "'/image/noimg.jpg'"
                            }
                          ]
                        })
                      ])
                ])
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("设备基础信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产描述全称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("品牌")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("型号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规格")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("商品标识码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("特种设备")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("使用方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("设备维保信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("保内")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("质保期(月)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("质保开始时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("质保到期时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需巡查")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需保养")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需要安装")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需要控温")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("故障次数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("维修次数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("最近维保时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("延保单")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("维保分组")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("定义描述全称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("设备保管信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务单元")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所在部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("责任部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("责任人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所在经度")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所在纬度")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("账面不符")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("设备使用信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("启用日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构启用日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("运行状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否在用")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否在库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("锁定")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("最近操作时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("最近扫码时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("领用部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("领用人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所属套装")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("设备统计信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单位")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务标签")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构标签")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("在库数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构使用时长(天)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构停用时长(分)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("本次闲置时长(时)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("以前闲置时长(时)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产基础信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产属性")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产分类")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("外部系统编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("可出租")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("可拆分")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("原始资产编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("使用方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产台账信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("折旧分摊规则编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("未税单价(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("含税单价(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("入账时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("入账方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计使用年限（月）")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("折旧方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当次折旧金额（元）")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("折旧完毕")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("残值率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("原值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("净值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("最后折旧月份")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("税率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("首次计提")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("累计折旧金额（元）")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("剩余折旧月数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("报废/弃用")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("报废日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("清理日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("清理原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产统计信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("在账数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("来源信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("批次号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("厂商序列号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("统一商品代码(UPC)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("卖家名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供商商户内部编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("初始合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("导入")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产图片")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产图片")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "operation-group" }, [
      _c("i", { staticClass: "icon iconfont icon-chakan view" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("型号图片")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "operation-group" }, [
      _c("i", { staticClass: "icon iconfont icon-chakan view" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f4345d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f4345d5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceSvcSubNoInfo.vue
// module id = 3169
// module chunks = 0